import { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const ImageCarousel = ({ photos = [], className = '' }) => {
  const [currentIdx, setCurrentIdx] = useState(0);

  if (!photos || photos.length === 0) return null;

  if (photos.length === 1) {
    return (
      <div className={`relative bg-gray-100 ${className}`} data-testid="image-carousel">
        <img
          src={photos[0]}
          alt=""
          loading="lazy"
          className="w-full max-h-[500px] object-contain"
        />
      </div>
    );
  }

  const goTo = (idx) => {
    if (idx < 0) idx = photos.length - 1;
    if (idx >= photos.length) idx = 0;
    setCurrentIdx(idx);
  };

  return (
    <div className={`relative bg-gray-100 group ${className}`} data-testid="image-carousel">
      <div className="relative overflow-hidden">
        <img
          src={photos[currentIdx]}
          alt=""
          loading="lazy"
          className="w-full max-h-[500px] object-contain transition-opacity duration-200"
        />
      </div>

      {/* Navigation arrows */}
      <button
        onClick={(e) => { e.stopPropagation(); goTo(currentIdx - 1); }}
        className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-black/40 hover:bg-black/60 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
        data-testid="carousel-prev"
      >
        <ChevronLeft className="w-5 h-5" />
      </button>
      <button
        onClick={(e) => { e.stopPropagation(); goTo(currentIdx + 1); }}
        className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-black/40 hover:bg-black/60 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
        data-testid="carousel-next"
      >
        <ChevronRight className="w-5 h-5" />
      </button>

      {/* Dots indicator */}
      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
        {photos.map((_, idx) => (
          <button
            key={idx}
            onClick={(e) => { e.stopPropagation(); goTo(idx); }}
            className={`w-2 h-2 rounded-full transition-all ${
              idx === currentIdx ? 'bg-white w-4' : 'bg-white/50'
            }`}
          />
        ))}
      </div>

      {/* Counter */}
      <div className="absolute top-3 right-3 bg-black/50 text-white text-xs font-bold px-2.5 py-1 rounded-full">
        {currentIdx + 1}/{photos.length}
      </div>
    </div>
  );
};
